export const  Messages = {
    "error": "ارسال اطلاعات با مشکل مواجه شد",
    "success": "با موفقیت ذخیره شد",
    "successDelete": "با موفقیت حذف شد",
}